/**
 * Reports → Call Reports → IVR Selection Report.
 *
 * One row per keypress. A nested menu is several rows for one call, because
 * the path a caller took ("2 then 4") is the routing question this report
 * exists to answer.
 */
import type { JSX } from 'react'
import { ListTree } from 'lucide-react'

import IvrSelectionAnalytics from '../../../components/reports/calls/IvrSelectionAnalytics.js'
import {
  IVR_SELECTION_COLUMNS,
  IVR_SELECTION_REPORT_ID,
} from '../../../components/reports/calls/columns.js'
import CallReportPage from './CallReportPage.js'

export default function IvrSelectionReportPage(): JSX.Element {
  return (
    <CallReportPage
      Icon={ListTree}
      title="IVR Selection Report"
      intro="What callers pressed, in which menu, and where it took them"
      unit="selection"
      path="/reports/calls/ivr-selection"
      reportId={IVR_SELECTION_REPORT_ID}
      catalog={IVR_SELECTION_COLUMNS}
      fields={[
        'ivrMenus', 'digits', 'includeNoSelection', 'directions', 'phone', 'queues',
        'campaigns', 'agents',
      ]}
      windowNote="The window is on the time the caller entered the menu."
      searchPlaceholder="Search selections…"
      renderAnalytics={(rows) => <IvrSelectionAnalytics rows={rows} />}
      emptyDescription="Choose a start date, an end date and an interval in Filters, then run the report."
      noResultsTitle="No IVR selections in this window"
      noResultsDescription="No caller pressed a key in an IVR menu in the selected scope. Try widening the window, clearing the IVR filters, or including visits where nothing was chosen."
    />
  )
}
